const METERS_PER_MILE = 1609.344;

export function metersToMiles(meters: number): number {
  return meters / METERS_PER_MILE;
}

export function milesToMeters(miles: number): number {
  return miles * METERS_PER_MILE;
}

export function roundToOneDecimal(num: number): number {
  return Math.round(num * 10) / 10;
}

export const roundToTwoDecimalsIfFractional = (num: number): number =>
  num % 1 === 0 ? num : +num.toFixed(2);
